import React, { useRef } from 'react';

import ModalVideo from '../ModalVideo';
import { MiguelTamara_Video1 } from '../../../../../utils/ES/Modals/aiArtists';

const ModalVideoMiguelTamara1 = () => {
  return (
    <>
      <ModalVideo
        id="miguel-tamara-video-1"
        dataText={MiguelTamara_Video1}
        videoSrc="https://www.youtube.com/embed/x6s90pWLIQc"
        videoTitle="KUTER_STUDIO_AI_MIGUEL_TAMARA_VIDEO_1"
      />
    </>
  );
};

export default ModalVideoMiguelTamara1;
